export default {
  content: {
    cols: { col: "", sm: "12", md: "4" },
    heading: { text: "{contact.first_name} Products" },
    subheading: { text: "We are here to serve you..." },
    content: { text: "Access your purchases here" },
    items: [],
  },
};
